import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

const UserPagination = ({
  currentPage,
  totalPages,
  totalUsers,
  itemsPerPage,
  onPageChange,
  maxPageNumbersToShow = 5,
}) => {
  const generatePageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  return (
    <div className="flex flex-row justify-between mt-4 items-center bg-white dark:bg-gray-900 dark:text-white text-gray-700">
      <p>
        Đã hiển thị người dùng từ {itemsPerPage * (currentPage - 1) + 1} đến{' '}
        {Math.min(itemsPerPage * currentPage, totalUsers)} trong tổng số {totalUsers} người dùng
      </p>
      <div className="flex justify-between items-center space-x-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded ${
            currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-200 dark:hover:bg-gray-700'
          }`}
        >
          <FontAwesomeIcon icon={faAngleLeft} className="text-xs" />
        </button>

        {currentPage > 1 && totalPages > maxPageNumbersToShow && (
          <span
            onClick={() => onPageChange(1)}
            className="cursor-pointer px-4 py-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            1
          </span>
        )}

        {currentPage > 2 && <span className="text-gray-500">...</span>}

        {generatePageNumbers().map((pageNumber) => (
          <span
            key={pageNumber}
            onClick={() => onPageChange(pageNumber)}
            className={`cursor-pointer px-4 py-2 rounded ${
              currentPage === pageNumber
                ? 'bg-blue-700 text-white'
                : 'hover:bg-gray-200 dark:hover:bg-gray-700'
            }`}
          >
            {pageNumber}
          </span>
        ))}

        {currentPage < totalPages - 1 && <span className="text-gray-500">...</span>}

        {currentPage < totalPages && totalPages > maxPageNumbersToShow && (
          <span
            onClick={() => onPageChange(totalPages)}
            className="cursor-pointer px-4 py-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            {totalPages}
          </span>
        )}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded ${
            currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-200 dark:hover:bg-gray-700'
          }`}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </button>
      </div>
    </div>
  );
};

export default UserPagination; 